import { IAdminProps, IPersonalCompanyProps } from '../../../_core/core.types';
import { ITableFilterOption } from '../../../_core/table/table.types';

export enum RequestTableType {
  ACTIVE = 'Inbox',
  WORKSPACE = 'Drafts',
  BULK = 'Bulk'
}

export interface IRequestTableContainer extends IAdminProps, IPersonalCompanyProps {}

export interface OnFilterChangeParams<T> {
  filters: ITableFilterOption<T>[];
  showingDrafts?: boolean;
}

export interface IRequestTableModeConfig {
  onChange: (selected: string) => void;
  options: RequestTableType[];
  value: string;
}
